<template>
  <footer class="app-footer">
    <div class="app-footer-inner">
      <span>© Tapes To Digital · {{ company }}</span>
      <span class="app-footer-links">
        <a :href="websiteUrl('/privacy-policy')">Privacy</a>
        <a :href="websiteUrl('/pricing')">Pricing</a>
        <a :href="websiteUrl('/locations')">All locations</a>
      </span>
    </div>
  </footer>
</template>

<script>
import { market, websiteUrl } from "@/utils/market";

// Links go to the market's website, not this app's own legal pages
export default {
  data: () => ({ company: market.company }),
  methods: { websiteUrl },
};
</script>

<style scoped>
.app-footer {
  margin-top: auto;
  border-top: 1px solid #e3e7ea;
  background: #fff;
}
.app-footer-inner {
  max-width: 1180px;
  margin: 0 auto;
  padding: 20px 24px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  font-size: 13px;
  color: #5b6168;
}
.app-footer-links {
  display: flex;
  gap: 18px;
}
@media (max-width: 599px) {
  .app-footer-inner {
    padding: 20px 16px;
  }
}
</style>
